import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any; 
import * as moment from "moment";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {


	newscategoryList: any = "";
	newscategoryrequest: any = {};
	newsList: any = "";
	newsallList: any = "";
	active_category: any = 1;
	bannerList: any = "";
	bannerrequest: any = {};
	
	newsrequest: any = {
		pagesize: 6,
		page: 1,
	
	};
	newsallrequest: any = {
		pagesize: 6,
		page: 1,
	
	};
	newsfirstrequest: any = {
		pagesize: 6,
		page: 1,
	};
	
	newsList_last_page: boolean;
	newsList_alllast_page: boolean;
	loading_page: boolean;

  constructor(private allpagesService: AllPageService,) { this.loadnews(); }

  ngOnInit() {
	  this.loadNewscategory();
	  this.loadnews();
	  this.loadallnews();
	  this.loadBanner();
  }

  loadNewscategory() {
	this.newscategoryrequest = {
		
	};
	let request = Object.assign({}, this.newscategoryrequest);
	this.allpagesService.getNewsCatagory(request).then((data: any) => {
		this.newscategoryList = data;
		console.warn(this.newscategoryList);
		setTimeout(() => {
			jQuery(".courses-name").click(function(){
				if(jQuery(this).hasClass('active')){
					// do nothing
				}else{
					var tabid = jQuery(this).attr('id');
					jQuery(".courses-name").removeClass('active');
					jQuery(this).addClass('active');
					jQuery(".course-main-content").removeClass('active');
					jQuery("#"+tabid+"-content").addClass("active");
				}
				return false;
			});

			jQuery('ul.category li a').click((e) => {
				this.loading_page = true;
				var dataid = e.currentTarget.id;
				this.active_category = dataid;
				console.log(this.active_category);
				this.newsrequest.news_catagory_id =  this.active_category;
				
				this.newsrequest = {
					pagesize: 6,
					page: 1,
					news_catagory_id: this.active_category
				
				};
				this.loadnewsfirst();
			});
		}, 1000);
	});
}
getMoreNews() {
	
	this.newsrequest.page = this.newsrequest.page + 1;
	this.loadnews(true);
	
  }
  getMoreallNews() {
	
	this.newsallrequest.page = this.newsallrequest.page + 1;
	this.loadallnews(true);
	
  }
  loadallnews(concat:boolean = false) {
	this.newsallrequest.news_catagory_id =  "";
	let request = Object.assign({}, this.newsallrequest);
	this.allpagesService.getNewsListing(request).then((data: any) => {
		
		if(data.data.length > 0)
       	{
			if (concat) {
			this.newsallList = this.newsallList.concat(data.data);
			console.warn(this.newsallList);
			
			} else {
			this.newsallList = data.data;
				console.log(this.newsallList);
			
		}   
       }else{
		//this.newsList = "";
        this.newsList_alllast_page = true;
		console.log("hello");
        
       }
		
	});
}

loadnews(concat:boolean = false) {
	this.newsrequest.news_catagory_id =  this.active_category;
	let request = Object.assign({}, this.newsrequest);
	this.allpagesService.getNewsListing(request).then((data: any) => {
		
		if(data.data.length > 0)
       	{
			if (concat) {
			this.newsList = this.newsList.concat(data.data);
			console.warn(this.newsList);
			
			} else {
			this.newsList = data.data;
				console.log(this.newsList);
			
			}   
			setTimeout(() => {
				this.loading_page = false;
			}, 1000);
			this.newsList_last_page = false;
       }else{
		//this.newsList = "";
        this.newsList_last_page = true;
		console.log("hello");
        
       }
		
	});
}
loadnewsfirst(concat:boolean = false) {
	this.newsfirstrequest.news_catagory_id =  this.active_category;
	let request = Object.assign({}, this.newsfirstrequest);
	this.allpagesService.getNewsListing(request).then((data: any) => {
		
		if(data.data.length > 0)
       	{
			if (concat) {
			this.newsList = this.newsList.concat(data.data);
			console.warn(this.newsList);
			
			} else {
			this.newsList = data.data;
				console.log(this.newsList);
			
		}  
		setTimeout(() => {
				this.loading_page = false;
			}, 1000);
		 
       }else{
		this.newsList = "";
        this.newsList_last_page = true;
		console.log("hello");
        
       }
		
	});
}

loadBanner() {
	this.bannerrequest = {
		title : 'News'
	};
	let request = Object.assign({}, this.bannerrequest);
	this.allpagesService.getBannerList(request).then((data: any) => {
		this.bannerList = data.data[0];
		console.log(this.bannerList);
	});
}

}
